import {
	baseApiHeaders,
	HIDE_TOAST_KEY,
	type IApiResponse,
	type IGetMarketAssetConverter,
	type ISellAssets,
	type ISubAccountTradeWalletAddresses,
	type ParamType,
} from 'BreetHelpers';

import { apiSlice } from './apiSlice';

export const tradesApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getSellAssets: builder.query<IApiResponse<ISellAssets[]>, void>({
			query: () => ({ url: '/trades/sell/assets' }),
			providesTags: ['GetSellAssets'],
		}),
		getMarketAssetConverter: builder.query<IApiResponse<IGetMarketAssetConverter>, Record<string, string> | undefined>({
			query: (params) => ({ url: '/trades/sell/assets/market/converter', params }),
		}),
		generateAssetsAddress: builder.mutation<IApiResponse, void>({
			query: () => ({
				method: 'POST',
				url: '/trades/sell/assets/addresses/vip',
				headers: { ...baseApiHeaders, [HIDE_TOAST_KEY]: 'true' },
			}),
			invalidatesTags: ['GetSellAssets'],
		}),
		generateSingleAssetsAddress: builder.mutation<IApiResponse, string>({
			query: (asesetId) => ({
				method: 'POST',
				url: `/trades/sell/assets/${asesetId}/address/vip`,
				headers: { ...baseApiHeaders, [HIDE_TOAST_KEY]: 'true' },
			}),
			invalidatesTags: ['GetSellAssets'],
		}),
		sellCompleteWithFees: builder.mutation<IApiResponse, string>({
			query: (transactionId) => ({
				method: 'POST',
				url: `/trades/sells/sell/${transactionId}/complete`,
				headers: { ...baseApiHeaders, [HIDE_TOAST_KEY]: 'true' },
			}),
			invalidatesTags: ['AllTransactions'],
		}),
		getTradesSubAccountWalletAddresses: builder.query<IApiResponse<ISubAccountTradeWalletAddresses[]>, ParamType>({
			query: (params) => ({
				url: '/trades/generated-wallets',
				params,
				headers: { ...baseApiHeaders, [HIDE_TOAST_KEY]: 'true' },
				...(params?.exports ? { responseHandler: (response: Response) => response.blob() } : {}),
			}),
			providesTags: ['GetTradesSubAccountWalletAddresses'],
		}),
	}),
});

export const {
	useGetSellAssetsQuery,
	useGenerateAssetsAddressMutation,
	useGetMarketAssetConverterQuery,
	useSellCompleteWithFeesMutation,
	useGenerateSingleAssetsAddressMutation,
	useGetTradesSubAccountWalletAddressesQuery,
} = tradesApiSlice;

export const selectSellAssets = tradesApiSlice.endpoints.getSellAssets.select();
export const selectMarketAssetConverter = (queryArg: Record<string, string>) =>
	tradesApiSlice.endpoints.getMarketAssetConverter.select(queryArg);
